import {createServiceFunction} from "@montana/services/http";

export const setMarketCookie = createServiceFunction((marketId: string) => {
    return f => f(`/api/set-market`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ marketId }),
    });
});
